import { RailsuiTooltip } from "railsui-stimulus"

export default class extends RailsuiTooltip {
  connect() {
    super.connect()

    this.element.setAttribute("aria-expanded", "false")

    this.onKeydown = this.onKeydown.bind(this)
    this.element.addEventListener("keydown", this.onKeydown)

    if (!this.tippy) return

    const { onHidden, onShow, onShown } = this.tippy.props
    this.tippy.setProps({
      onHidden: (...args) => {
        this.element.setAttribute("aria-expanded", "false")
        if (typeof onHidden === "function") onHidden(...args)
      },
      onShow: (...args) => {
        this.element.setAttribute("aria-expanded", "true")
        if (typeof onShow === "function") onShow(...args)
      },
      onShown: (...args) => {
        this.element.setAttribute("aria-expanded", "true")
        if (typeof onShown === "function") onShown(...args)
      },
    })
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.onKeydown)
    super.disconnect()
  }

  onKeydown(event) {
    if (!this.tippy) return

    if (event.key === "Escape") {
      this.tippy.hide()
      this.element.focus()
      return
    }

    if (event.key !== "Enter" && event.key !== " ") return

    event.preventDefault()
    if (this.tippy.state?.isVisible) {
      this.tippy.hide()
      return
    }

    this.tippy.show()
  }
}
